// src/components/auto/AutoFilters.jsx - Fixed version with native selects on mobile
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Filter, X } from "lucide-react";

export default function AutoFilters({ 
  filters, 
  setFilters, 
  clienti = [], 
  stati = [], 
  isMobile = false 
}) {
  const handleFilterChange = (key, value) => {
    console.log('🎛️ Filter change:', key, '=', value);
    const newFilters = {
      ...filters,
      [key]: value
    };
    console.log('📤 Sending new filters:', newFilters);
    setFilters(newFilters);
  };

  const hasActiveFilters = filters.stato !== "all" || filters.cliente !== "all";

  const clearFilters = () => {
    console.log('🧹 Clearing filters');
    setFilters({
      stato: "all",
      cliente: "all"
    });
  };

  // Native select component for mobile
  const NativeSelect = ({ value, onChange, options, placeholder, label }) => {
    return (
      <div className="space-y-1">
        <Label className="text-xs font-medium text-slate-600">{label}</Label>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full p-2 border border-slate-300 rounded-md text-base bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          style={{ minHeight: '44px' }} // iOS touch target size
        >
          <option value="all">{placeholder}</option>
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    );
  };

  // Prepare options for native selects
  const statiOptions = stati.map(stato => ({ id: stato.id, name: stato.nome }));
  const clientiOptions = clienti.map(cliente => ({ 
    id: cliente.id, 
    name: `${cliente.nome} ${cliente.cognome}`.trim() 
  }));

  if (isMobile) {
    return (
      <div className="space-y-3">
        {/* Mobile Native Selects */}
        <div className="grid grid-cols-1 gap-3">
          {/* Status Filter - Native */}
          <NativeSelect
            value={filters.stato}
            onChange={(value) => handleFilterChange("stato", value)}
            options={statiOptions}
            placeholder="Tutti gli stati"
            label="Stato"
          />

          {/* Client Filter - Native */}
          <NativeSelect
            value={filters.cliente}
            onChange={(value) => handleFilterChange("cliente", value)}
            options={clientiOptions}
            placeholder="Tutti i clienti"
            label="Cliente"
          />
        </div>

        {/* Mobile Filter Summary */}
        {hasActiveFilters && (
          <div className="flex items-center justify-between text-xs text-slate-600 bg-blue-50 p-2 rounded border">
            <span>
              Filtri attivi: {filters.stato !== "all" && "Stato"} {filters.cliente !== "all" && "Cliente"}
            </span>
            <Button
              onClick={clearFilters}
              variant="ghost"
              size="sm"
              className="h-6 px-2 text-xs"
            >
              <X className="w-3 h-3" />
            </Button>
          </div>
        )}
      </div>
    );
  }

  // Desktop Layout - Keep shadcn Select for better UX
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Status Filter - Desktop */}
      <div className="min-w-[200px]">
        <Select
          value={filters.stato}
          onValueChange={(value) => handleFilterChange("stato", value)}
        >
          <SelectTrigger className="bg-white shadow-sm">
            <Filter className="w-4 h-4 mr-2 text-slate-400" />
            <SelectValue placeholder="Filtra per stato" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-y-auto">
            <SelectItem value="all">Tutti gli stati</SelectItem>
            {stati.map((stato) => (
              <SelectItem key={stato.id} value={stato.id}>
                {stato.nome}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Client Filter - Desktop */}
      <div className="min-w-[250px]">
        <Select
          value={filters.cliente}
          onValueChange={(value) => handleFilterChange("cliente", value)}
        >
          <SelectTrigger className="bg-white shadow-sm">
            <Filter className="w-4 h-4 mr-2 text-slate-400" />
            <SelectValue placeholder="Filtra per cliente" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-y-auto">
            <SelectItem value="all">Tutti i clienti</SelectItem>
            {clienti.map((cliente) => (
              <SelectItem key={cliente.id} value={cliente.id}>
                {cliente.nome} {cliente.cognome}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Clear Filters Button - Desktop */}
      {hasActiveFilters && (
        <Button
          onClick={clearFilters}
          variant="outline"
          className="text-slate-600 border-slate-300"
        >
          <X className="w-4 h-4 mr-2" />
          Cancella filtri
        </Button>
      )}
    </div>
  );
}